import { marqueeInnerMarkup } from './marquee-markup';

const marqueeCreate = async (projects, marqueeContainer) => {
  const strMarkup = marqueeInnerMarkup(projects);
  marqueeContainer.innerHTML = '';
  marqueeContainer.insertAdjacentHTML('beforeend', strMarkup);
};

export default marqueeCreate;
